const BUSINESS_2FA_TRUST_PREFIX = 'aacore_business_2fa_trust:';
const BUSINESS_2FA_SESSION_PREFIX = 'aacore_business_2fa_session:';

function trustStorageKey(email: string): string {
  return `${BUSINESS_2FA_TRUST_PREFIX}${email.trim().toLowerCase()}`;
}

function sessionVerifiedKey(userId: string): string {
  return `${BUSINESS_2FA_SESSION_PREFIX}${userId}`;
}

/** Opaque trust token for skipping business 2FA on this browser (keyed by login email). */
export function getBusiness2faTrustToken(email: string): string | null {
  try {
    const value = localStorage.getItem(trustStorageKey(email));
    return value && value.trim() ? value.trim() : null;
  } catch {
    return null;
  }
}

export function setBusiness2faTrustToken(email: string, trustToken: string): void {
  try {
    localStorage.setItem(trustStorageKey(email), trustToken);
  } catch {
    // best-effort
  }
}

export function clearBusiness2faTrustToken(email: string): void {
  try {
    localStorage.removeItem(trustStorageKey(email));
  } catch {
    // best-effort
  }
}

/** Session-scoped flag so step-up 2FA is not repeated while the tab session is open. */
export function markBusiness2faVerifiedThisSession(userId: string): void {
  try {
    sessionStorage.setItem(sessionVerifiedKey(userId), '1');
  } catch {
    // best-effort
  }
}

export function isBusiness2faVerifiedThisSession(userId: string): boolean {
  try {
    return sessionStorage.getItem(sessionVerifiedKey(userId)) === '1';
  } catch {
    return false;
  }
}

export function clearBusiness2faVerifiedThisSession(userId?: string): void {
  try {
    if (userId) {
      sessionStorage.removeItem(sessionVerifiedKey(userId));
      return;
    }
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(BUSINESS_2FA_SESSION_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // best-effort
  }
}
